<template>
  <div class="flex w-full flex-col gap-6 p-6">
    <nav class="pb-3" aria-label="Breadcrumb">
      <ol class="flex space-x-1 truncate text-xs md:space-x-4 md:text-sm">
        <li>
          <div>
            <router-link to="/" class="text-gray-400 hover:text-gray-400">
              <span v-html="$icons.home"></span>

              <span class="sr-only">Home</span>
            </router-link>
          </div>
        </li>
        <li v-for="(item, i) in breadcrumb" :key="i">
          <div class="flex items-center">
            <span class="text-gray-400" v-html="$icons.chevron_right"></span>

            <router-link
              :to="item.url"
              class="ml-1 text-xs font-medium text-gray-400 hover:text-gray-700 md:ml-4 md:text-sm"
            >
              {{ item.name }}
            </router-link>
          </div>
        </li>
      </ol>
    </nav>
    <div class="flex items-center justify-between">
      <div>
        <div class="flex items-center gap-4">
          <i v-html="$icons.edit_document"> </i>
          <h3 class="text-2xl font-bold">Pré-autorizações de Trade Ideas</h3>
        </div>
        <span class="text-sm text-gray-500 dark:text-gray-400">
          Deixe suas Trade Ideas pré autorizadas por um prazo determinado.
        </span>
      </div>
    </div>
    <div class="flex w-full flex-col gap-4">
      <div class="flex items-center justify-between">
        <div
          class="bg-ontick-graphite-500 ring-ontick-blue-800 relative flex h-10 items-center overflow-hidden rounded text-sm focus-within:ring-2"
        >
          <button
            class="absolute left-0 top-0 flex h-full items-center justify-center px-2 filter transition-all hover:brightness-125"
          >
            <i v-html="$icons.search"> </i>
          </button>
          <input type="text" class="border-0 bg-transparent pl-10" placeholder="Buscar" v-model="search" />
        </div>
        <router-link :to="{ name: 'Nova autorização Trade Ideas v2' }">
          <button
            class="bg-ontick-blue-600 dark:bg-ontick-blue-900 flex h-10 items-center gap-2 rounded px-4 text-sm font-semibold text-white shadow filter transition-all hover:brightness-110"
          >
            <i v-html="$icons.plus_sm"></i>
            <span> Nova autorização </span>
          </button>
        </router-link>
      </div>
      <auth-table-component
        :authorizations="filteredAuthorizations"
        :tableHead="tableHead"
        type="trade_ideas"
        @reload="getData"
      />
    </div>

    <!-- <div
      v-else
      class="flex items-center justify-center py-16 text-2xl font-bold"
    >
      <p>Nenhuma autorização encontrada</p>
    </div> -->
    <ontick-modal-component :open="detailsModalIsActive" size="small" @close="detailsModalIsActive = false">
      <auth-details-component :authId="detailsId" />
    </ontick-modal-component>
  </div>
</template>

<script>
import ontickBrokerLogoComponent from "../../../shared/components/basic/ontick-broker-logo.component.vue";
import { mapGetters } from "vuex";
import OntickModalComponent from "../../../shared/components/basic/ontick-modal.component.vue";
import AuthDetailsComponent from "../components/auth-details.component.vue";
import event_bus from "../../../shared/utils/event_bus";
import AuthTableComponent from "../components/auth-table.component.vue";
import routes from "../../../core/config/api-ontick.routes";

export default {
  components: {
    ontickBrokerLogoComponent,
    OntickModalComponent,
    AuthDetailsComponent,
    AuthTableComponent,
  },

  data() {
    return {
      authorizations: [],
      detailsModalIsActive: false,
      detailsId: null,
      tableHead: [
        {
          label: "Status",
          visible: false,
        },
        {
          label: "ID",
          visible: true,
        },
        {
          label: "Conta",
          visible: true,
        },
        {
          label: "Parceiro",
          visible: true,
        },
        {
          label: "Estratégia",
          visible: true,
        },
        {
          label: "Analista",
          visible: true,
        },
        // {
        //   label: "Máx. operações",
        //   visible: true,
        // },
        {
          label: "Alocação máxima",
          visible: true,
        },
        {
          label: "Data de aprovação",
          visible: true,
        },
      ],
      search: "",
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      getSelectedAccount: "accountTypes/getSelectedAccount",
      getConfigs: "config/getConfigs",
    }),

    breadcrumb() {
      return [
        {
          name: "Trade Ideas",
          url: { name: "Trade Ideas v2" },
        },
        {
          name: this.routeName,
          url: { name: this.$route.name },
        },
      ];
    },
    routeName() {
      switch (this.$route.name) {
        case "Pré-autorização Trade Ideas v2":
          return "Pré-autorização";
        default:
          return this.$route.name;
      }
    },
    filteredAuthorizations() {
      return this.authorizations;
    },
  },

  methods: {
    async getData() {
      this.loading = true;
      try {
        const { data } = await this.$api.get(routes.LIST_TRADE_IDEAS_AUTHORIZATIONS, {
          params: { account_id: this.getSelectedAccount.account_id },
        });
        // console.log(data);
        this.authorizations = data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async disableTradeIdea(aut_id) {
      const body = {
        account_id: this.getSelectedAccount.account_id,
        aut_id,
      };
      try {
        const { data } = await this.$api.post(routes.DISABLE_TRADE_IDEA_AUTHORIZATION, { body });
        // console.log(data);
      } catch (err) {
        console.error(err);
      }
    },
  },

  mounted() {
    this.getData();
  },
};
</script>
